import React, { useContext, useEffect, useState } from "react";
// import { makeStyles } from "@material-ui/core/styles";
import MCQ from "./questions-web/MCQ";
import FITB from "./questions-web/FITB";
import TF from "./questions-web/TF";
import MC from "./questions-web/MC";
import ThingsContext from "../PublicLayout/thingsContext";

import { getWebQuestions } from "./lib/sync/questionsLib";

export default function QuestionSearch({ assessment_id, question_count }) {
  // const classes = useStyles();
  const [questions, setQuestions] = useState([]);
  const [load, setLoad] = useState(false);
  const [things] = useContext(ThingsContext);

  const fetchNew = () => {
    setQuestions([]);
    getWebQuestions(assessment_id, things, question_count)
      .then((items) => {
        if (items.length === 0) {
          setLoad(true);
          setQuestions([]);
        } else {
          setQuestions(items);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  useEffect(() => {
    setQuestions([]);
    getWebQuestions(assessment_id, things, question_count)
      .then((items) => {
        console.log("items", items);
        if (items.length === 0) {
          setLoad(true);
          setQuestions([]);
          // return;
        } else {
          setQuestions(items);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }, [assessment_id, things, question_count]);

  return questions.length ? (
    questions.map((item, index) => {
      let qType = item.question.Qtype;
      let total_num = item.total_num;

      return (
        <React.Fragment key={index}>
          {total_num} OUT OF {question_count}
          {qType === "MCQ" && <MCQ fetchNew={fetchNew} item={item} />}
          {qType === "True False" && <TF fetchNew={fetchNew} item={item} />}
          {qType === "Fill in the Blanks" && (
            <FITB fetchNew={fetchNew} item={item} />
          )}
          {qType === "Match Column" && <MC fetchNew={fetchNew} item={item} />}
        </React.Fragment>
      );
    })
  ) : (
    <div key={1}>
      <h1 style={{ marginBottom: "0" }}>{question_count} Questions Performed, Hit Next.</h1>
    </div>
  );
}
